<template>
  <div class="page-integrations__wrapper">
    <vtitle />

    <div class="page-integrations">
      <div>
        <vinput
          v-model="moduleName"
          :loading="loading || loading_module"
          class="page_tests_input"
          :placeholder="$tr('vacancy.integrations.form.name')"
          border
          focus
        />

        <vtextarea
          v-model="moduleDescription"
          :loading="loading || loading_module"
          class="page_tests_textarea"
          :height="84"
          :placeholder="$tr('vacancy.integrations.form.description')"
        />
      </div>

      <div class="page-integrations__integrations">
        <container
          group-name="integrations"
          lock-axis="y"
          drag-handle-selector=".dragging__dots"
          @drop="integrationsOnDrop"
        >
          <draggable v-for="(item, index) in integration_list.url" :key="index">
            <div class="page-integrations__integration">
              <div class="dragging__dots">
                <div class="dragging__dot"></div>
                <div class="dragging__dot"></div>
                <div class="dragging__dot"></div>
              </div>

              <vinput
                v-validate="'required|url'"
                :value="item"
                :name="`link ${index}`"
                :class="{ error: errors.has(`link ${index}`) }"
                :placeholder="$tr('vacancy.modules.integration.input')"
                :disabled="isIntegrationDisabled(item)"
                border
                @input="UPDATE_INTEGRATION({ index, value: $event })"
              />

              <vbutton
                v-if="!isIntegrationDisabled(item)"
                :disabled="integration_list.url.length === 1"
                :text="$tr('common.delete')"
                color="grey"
                @click="REMOVE_LINK_INTEGRATION(item)"
              />
            </div>
          </draggable>
        </container>
      </div>

      <div class="page-integrations__custom-field">
        <vinput
          v-if="isShowCustomField"
          v-model="customIntegration"
          v-validate="{ required: true, url: { require_protocol: true } }"
          name="custom"
          :class="{ error: errors.has('custom') || integration_list.url.includes(customIntegration) }"
          :placeholder="$tr('vacancy.modules.integration.input')"
          :disabled="loading || loading_module"
          border
        />

        <vbutton
          :text="isShowCustomField ? $tr('common.delete') : $tr('integrations.common.add-custom-integration')"
          color="grey"
          @click="isShowCustomField = !isShowCustomField"
        />
      </div>

      <div class="row-block button-wrapper">
        <vbutton
          :loading="loading || loading_module"
          :disabled="isSaveDisabled"
          class="vacancy-button"
          label="common.save"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Vtitle from '@/routes_new/inner/vacancy/components/vtitle';
import { Container, Draggable } from 'vue-smooth-dnd';

export default {
  name: 'ExternalIntegrationDefault',

  components: {
    Vtitle,
    Container,
    Draggable
  },

  data() {
    return {
      isShowCustomField: false,
      customIntegration: '',
      moduleName: '',
      moduleDescription: ''
    };
  },

  computed: {
    ...mapState('integrations', ['integration_list', 'loading', 'loading_module']),

    ...mapState('vacancy_new', { vacancyId: state => state.item.id, modules: state => state.modules.list }),

    isSaveDisabled() {
      // Если новая интеграция есть уже в списке выше
      if (
        this.integration_list.url !== undefined &&
        this.integration_list.url.length > 0 &&
        this.integration_list.url.includes(this.customIntegration)
      ) {
        return true;
      } else if (
        this.integration_list.url !== undefined &&
        this.integration_list.url.length <= 0 &&
        this.customIntegration === ''
      ) {
        return true;
      }

      return false;
    }
  },

  async created() {
    await this.fetchModuleInfo(this.vacancyId).then(res => {
      this.moduleName = res.data.name;
      this.moduleDescription = res.data.description;
    });

    await this.fetchIntegrations(this.vacancyId);
  },

  destroyed() {
    this.CLEAR_INTEGRATIONS();
  },

  methods: {
    ...mapMutations('integrations', [
      'CLEAR_INTEGRATIONS',
      'REMOVE_LINK_INTEGRATION',
      'SET_INTEGRATION_LIST_LINKS',
      'SET_LOADING',
      'UPDATE_INTEGRATION'
    ]),

    ...mapActions('integrations', [
      'fetchModuleInfo',
      'fetchIntegrations',
      'addIntegration',
      'updateIntegration',
      'updateModuleInfo'
    ]),

    isIntegrationDisabled(link) {
      const arrayOfDisabled = ['vcv.team', 'vcv.dev', 'vcv.ru', 'vcv.ai'];

      for (let i = 0; i < arrayOfDisabled.length; i++) {
        if (link.includes(arrayOfDisabled[i])) return true;
      }

      return false;
    },

    integrationsOnDrop(dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return this.integration_list.url;

      const result = [...this.integration_list.url];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      this.SET_INTEGRATION_LIST_LINKS(result);
    },

    async saveModule() {
      let data = { name: this.moduleName, description: this.moduleDescription };

      await this.updateModuleInfo({ vacancy_id: this.vacancyId, data });
    },

    async save() {
      this.$validator.validate().then(async valid => {
        if (valid) {
          await this.saveModule();

          this.SET_LOADING(true);

          if (this.integration_list.url !== undefined && this.integration_list.url.length === 0) {
            let data = { url: [this.customIntegration], vacancy_id: Number(this.vacancyId) };

            await this.addIntegration(data)
              .then(() => {
                this.customIntegration = '';
                this.isShowCustomField = false;
                this.$noty.success(this.$tr('vacancy.modules.integration.savedSuccess'));
              })
              .catch(() => {
                this.$noty.error(this.$tr('vacancy.modules.integration.savedError'));
              })
              .finally(() => {
                this.SET_LOADING(false);
              });
          } else {
            let urls = this.integration_list.url.slice(0);

            if (this.customIntegration) {
              urls.push(this.customIntegration);
            }

            let data = { url: urls, id: this.integration_list.id };

            await this.updateIntegration(data)
              .then(() => {
                this.customIntegration = '';
                this.isShowCustomField = false;
                this.$noty.success(this.$tr('vacancy.modules.integration.savedSuccess'));
              })
              .catch(() => {
                this.$noty.error(this.$tr('vacancy.modules.integration.savedError'));
              })
              .finally(() => {
                this.SET_LOADING(false);
              });
          }

          // await this.fetchIntegrations(this.vacancyId).catch(() => {
          //   this.$noty.error(this.$tr('vacancy.modules.integration.savedError'));
          // });
        } else {
          this.$noty.error(this.$tr('profile.modals.saveFailure.text'));
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dragging__dots {
  cursor: grab;
  position: relative;
  left: 0;
  top: 8px;
  margin-right: 10px;

  .dragging__dot {
    width: 4px;
    height: 4px;
    background-color: #d2d6e0;
    border-radius: 50%;
    margin: 3px 2px;
    display: block;
  }
}

.page-integrations {
  margin-top: 4px;

  &__wrapper {
    max-width: 700px;
  }

  &__custom-field {
    display: flex;
    justify-content: space-between;

    .vinput {
      flex: 1;
    }
  }

  &__integration {
    display: flex;
    background: $white;
    margin-bottom: 5px;
    box-shadow: 0 0 rgba(0, 0, 0, 0);
    padding: 10px;
    border: 1px solid $grey-light;
    justify-content: space-between;
    transition: box-shadow 0.3s;

    .vinput {
      flex: 1;
    }
  }

  .smooth-dnd-ghost .page-integrations__integration {
    box-shadow: $box-shadow;
    transition: box-shadow 0.3s;
  }

  &__integrations {
    margin: 20px 0;
  }

  &__field {
    display: flex;
    justify-content: space-between;
    border: 1px solid $grey-light;
    box-shadow: $box-shadow;

    .vinput {
      flex: 1;
    }
  }

  .vinput.error {
    margin-top: 0 !important;

    input {
      border-color: #e64747;
    }
  }

  .page_tests_input {
    max-width: 100%;
    min-width: 100%;
    margin-bottom: 20px;
  }

  .page_tests_textarea {
    max-width: 100%;
    min-width: 100%;
    min-height: 84px;
    max-height: 84px;
  }

  ::v-deep .page_tests_textarea.vtextarea {
    .textarea {
      padding: 8px 15px;
      border: 1px solid $grey-light;
      transition: border 0.3s;

      &:focus {
        border: 1px solid $green;
        transition: border 0.3s;
      }
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .vacancy-button:not(:last-child) {
      margin-right: 10px;
    }
  }

  &__link-item {
    position: relative;
  }
}

::v-deep input.input_block {
  width: 72px;
  padding: 8px 11px;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
}

::v-deep .input_block {
  margin-left: 8px;

  .input {
    width: 62px;
    padding: 8px 11px;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0;
    border: 1px solid $grey-light;
    border-radius: 2px;
  }
}
</style>
